import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";

import "./Upload.scss";

const KILO_BYTES_PER_BYTE = 1000;
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 500000;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

export const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

export const Upload = forwardRef(
  ({ text, updateFilesCallback, maxFileSizeInBytes, ...props }, ref) => {
    const [files, setFiles] = useState();
    const fileInputField = useRef();

    useImperativeHandle(ref, () => ({
      inputClick: () => {
        fileInputField.current.click();
      },
    }));

    const addNewFiles = (newFiles) => {
      for (const file of newFiles) {
        if (maxFileSizeInBytes && file.size > maxFileSizeInBytes) continue;
        if (!props.multiple) return { file };

        files[file.name] = file;
      }
      return { ...files };
    };

    const callUpdateFilesCb = (files) => {
      const filesAsArray = convertNestedObjectToArray(files);

      updateFilesCallback && updateFilesCallback(filesAsArray);
    };

    const newFileUploadHandler = (e) => {
      const { files: newFiles } = e.target;

      if (newFiles.length) {
        const updatedFiles = addNewFiles(newFiles);

        setFiles(updatedFiles);
        callUpdateFilesCb(updatedFiles);
      }
    };

    const removeFileHandler = (fileName) => {
      delete files[fileName];

      setFiles({ ...files });
      callUpdateFilesCb({ ...files });
    };

    return (
      <div
        role="button"
        className="upload-input rounded-10 px-4 py-3"
        style={props.style}
        onClick={() => fileInputField.current.click()}
      >
        <input
          type="file"
          accept={props.accept || ".jpg,.png,.jpeg"}
          ref={fileInputField}
          onChange={newFileUploadHandler}
          className="d-none"
        />
        {text ?? props.children}
      </div>
    );
  },
);
